export const COURSE_CODE_ALIASES = Object.freeze({
  "2.7.3": "2.7.2",
  "2.4.1": "2.4.2",
  "1.4.2": "1.4.3",
  "1.3.1": "10.1.1",
  "2.3.3": "1.1.2",
  "2.1.1": "2.7.2",
  "2.1.3": "2.2.3",
  "1.5.1": "1.5.2",
  "2.2.4": "1.1.2",
  "3.2.2": "3.2.1",
  "3.3.1": "3.3.2",
  "4.1.3": "4.1.1",
  "4.2.2": "4.2.1",
  "4.3.4": "4.3.1",
  "5.1.4": "5.2.3",
  "5.1.3": "5.1.2",
  "5.2.1": "5.2.3",
  "6.1.2": "6.1.9",
  "6.2.3": "6.5.3",
  "6.5.2": "6.5.3",
  "6.3.1": "6.3.2",
  "7.1.3": "7.1.2",
  "8.2.1": "8.1.3",
  "8.2.2": "8.1.3",
  "8.2.3": "8.1.3",
  "8.3.2": "8.3.1",
  "9.1.2": "9.1.1",
  "9.1.3": "9.1.1",
  "9.1.4": "9.1.1",
});

export const getMaturaCourseCode = code => COURSE_CODE_ALIASES[code] || code;
